import { render, staticRenderFns } from "./CompSpeak.vue?vue&type=template&id=14dce58a&"
import script from "./CompSpeak.vue?vue&type=script&lang=ts&"
export * from "./CompSpeak.vue?vue&type=script&lang=ts&"
import style0 from "./CompSpeak.vue?vue&type=style&index=0&id=14dce58a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports